import cuid from "cuid";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Create = () => {
  const navigate = useNavigate();
  const id = useMemo(() => cuid(), []);
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.FLOWS.LIST.path);
  const [addFlow] = useMutation(graphql.mutations.CREATE_FLOW, {
    refetchQueries: [
      {
        query: graphql.queries.FLOWS,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
    ],
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.FLOWS.LIST.path);
    },
    onError: () => {},
  });
  const onSubmit = (data) => {
    const { name, tracers, process } = data;
    return addFlow({
      variables: {
        data: {
          id,
          name,
          tracers: tracers.map((tracer) => ({ id: tracer })),
          process,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} id={id} cancel={cancel} />;
};

export default Create;
